import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/auth.context';

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        Loading...
      </div>
    );
  }

  if (user) {
    return <Navigate to="/networth" replace />;
  }

  return children;
};

export default PublicRoute;
